import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import '../styles/Footer.css';

const Footer = () => {
  const location = useLocation();
  const { pathname } = location;
  //console.log('pathname', pathname);

  const isHome = pathname === '/';
  const hideFooter = pathname === '/interview';
  const isMinimalFooter = [
    '/feedback',
    '/session-ended',
    '/setup',
    '/terms',
    '/privacy',
    '/how-to-use',
  ].includes(pathname);

  //console.log('isMinimalFooter', isMinimalFooter);
  if (hideFooter) return null;

  if (isHome) {
    return (
      <footer className='footer'>
        <div className='footer-content'>
          <div className='footer-logo'>AURON</div>
          <div className='footer-links'>
            <a href='/auron/terms' target='_blank' rel='noopener noreferrer'>
              Terms of Service
            </a>
            <Link to='/privacy'>Privacy Policy</Link>
            <a href='mailto:contact@auron.ai'>Contact</a>
          </div>
          <div
            className='footer-powered-by'
            style={{ marginTop: '10px', fontSize: '0.95rem', color: '#a0a0a0' }}
          >
            AI responses powered by OpenAI's ChatGPT model.
          </div>
          <p className='copyright'>© 2025 Auron Interview Assistant. All rights reserved</p>
        </div>
      </footer>
    );
  }

  if (isMinimalFooter) {
    return (
      <footer className='setup-footer'>
        <p className='copyright'>© 2025 Auron Interview Assistant. All rights reserved</p>
      </footer>
    );
  }

  return null;
};

export default Footer;
